<template> 
<v-container class="flex" fluid fill-height>
 <v-layout row fill-height>
   <v-flex pa-3 class="pan" xs-6 fill-height >
      <v-text-field v-model="url" label="commande"></v-text-field>
      <label>Paramètres</label><br/>
      <v-select v-model="method" label="Method" :items="['GET','POST','PUT','DELETE']"></v-select><br/>
      <textarea :class="{ko:!paramValid}" v-model="strData" ></textarea><br/>
      <v-btn color="primary" @click="sendcommande">Envoyer</v-btn>
      <hr/>
      <v-btn color="secondary" @click="configAuthTest1">Auth Test 1</v-btn>
   </v-flex>   
   <v-flex pa-3 xs-6 >
     <h2>Result</h2>
     <textarea v-model="result" class="result"></textarea>
   </v-flex>
 </v-layout>
 </v-container>
</template>
<script>  
  import apiHelpers from '@/utils/api'
  export default {
    name: 'Training',
    data() {
      return {   
        url:"",
        method:"GET",
        paramData:{},
        paramStrData:"{}",
        paramValid:true,
        result:""
      }
    },
    computed:{
      strData :{
        get() {
          return this.paramStrData
        },
        set(newValue) {
          this.paramStrData = newValue
          try {
            const tmpData = JSON.parse(newValue)            
            this.data = tmpData
            this.paramValid = true
          }
          catch(e){
            this.paramValid = false
          }
        }
      },
      data: {
          get(){
            return this.paramData
          },
          set(newValue) {
            this.paramData = newValue
            this.paramStrData = JSON.stringify(newValue)
          }
      }
    },
    methods: {  
      sendcommande(){        
        apiHelpers.apiCall({ url:this.url, method:this.method, data: this.data } ).then((resp) => {
          this.result = JSON.stringify(resp)
        }).catch((e) => {
          this.result =  e + '\r\n-------------------\r\n' + JSON.stringify(e) 
        })
      },
      configAuthTest1(){
        this.url = "api/auth"
        this.method = 'POST'
        this.data = {
          UserName : "@glimms",
          Password : "Se@Xplorer2019"
        }
      }   
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .pan{
    border-right:1px solid #ccc;
  }
  .ko{
    border:1px solid #ff0000;
  }

  textarea{
    border: 1px solid #ccc;
    width:100%;
    min-height: 500px;
  }
  .result{
    height:100%;
  }
</style>
